import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  constructor(private http: HttpClient) {}

  public download(url: string, fallbackFileName = 'download.bin'): Observable<void> {
    return this.http
      .get(url, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap(response => {
          if (!response.body) return;

          const fileName = this.getFileNameFromResponse(response) || this.getFileNameFromUrl(url) || fallbackFileName;

          this.saveFile(response.body, fileName);
        }),
        map(() => void 0)
      );
  }

  private getFileNameFromResponse(response: HttpResponse<Blob>): string | null {
    const contentDisposition = response.headers.get('content-disposition');
    if (!contentDisposition) return null;

    const utfMatch = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(contentDisposition);
    if (utfMatch) {
      return decodeURIComponent(utfMatch[1]);
    }

    const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);

    return match ? match[1].replace(/['"]/g, '') : null;
  }

  private getFileNameFromUrl(url: string): string | null {
    try {
      const parsed = new URL(url);
      const pathname = parsed.pathname;
      const name = pathname.substring(pathname.lastIndexOf('/') + 1);
      return name || null;
    } catch {
      return null;
    }
  }

  private saveFile(blob: Blob, fileName: string) {
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  }
}
